import type {
  HotelSelectionListLengthVariant,
  StatsigMultiExperimentName,
} from '@libs/feature-toggle';

export const HOTEL_SELECTION_LIST_LENGTH_CONTROL_VARIANT: HotelSelectionListLengthVariant =
  'size200';

const HOTEL_SUGGESTIONS_SIZE_50 = 50;
const HOTEL_SUGGESTIONS_SIZE_100 = 100;
const HOTEL_SUGGESTIONS_SIZE_150 = 150;
const HOTEL_SUGGESTIONS_SIZE_200 = 200;
const HOTEL_SUGGESTIONS_SIZE_250 = 250;

export function getHotelSelectionListLengthExperimentName(
  isMobile: boolean
): StatsigMultiExperimentName {
  return isMobile
    ? 'hotel_selection_list_length_mobile'
    : 'hotel_selection_list_length_desktop';
}

export function getNumberOfHotelSuggestions(variant: string): number {
  switch (variant) {
    case 'size50':
      return HOTEL_SUGGESTIONS_SIZE_50;
    case 'size100':
      return HOTEL_SUGGESTIONS_SIZE_100;
    case 'size150':
      return HOTEL_SUGGESTIONS_SIZE_150;
    case 'size250':
      return HOTEL_SUGGESTIONS_SIZE_250;
    case 'size200':
    default:
      return HOTEL_SUGGESTIONS_SIZE_200;
  }
}
